import React from 'react'
import PropTypes from 'prop-types'
import { YouthPageTemplate } from '../../templates/youth-page'
import { HTMLContent } from '../../components/Content'

const YouthPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <YouthPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
        infants={data.infants}
        infantsinfo={data.infantsinfo}
        toddlers={data.toddlers}
        toddlersinfo={data.toddlersinfo}
        children={data.children}
        childreninfo={data.childreninfo}
        middleschool={data.middleschool}
        middleschoolinfo={data.middleschoolinfo}
        highschool={data.highschool}
        highschoolinfo={data.highschoolinfo}
        college={data.college}
        collegeinfo={data.collegeinfo}
        contentComponent={HTMLContent}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

YouthPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
  contentComponent: PropTypes.func,
}

export default YouthPagePreview
